import { useState } from "react";
import { Input } from "../../../components/ui/input";

export const fmt = (n, d = 0) => (n === null || n === undefined || n === "" ? "—" : Number(n).toLocaleString("tr-TR", { maximumFractionDigits: d }));
export const TL = (n) => (n === null || n === undefined ? "—" : `${fmt(n)} ₺`);
export const CH = { google_ads: "Google Ads", organik: "Organik", direkt: "Direkt", meta_ads: "Meta Reklam", sosyal: "Sosyal", referans: "Referans", diger_reklam: "Diğer reklam", belirtilmemis: "Belirtilmemiş", qr_etiket: "QR etiket", bayi: "Bayi" };
export const chLabel = (c) => CH[c] || c || "—";
const iso = (d) => d.toLocaleDateString("sv-SE", { timeZone: "Europe/Istanbul" });   // YYYY-MM-DD, İstanbul günü

export function useRange(days = 30) {
  const to = new Date(); const from = new Date(Date.now() - (days - 1) * 864e5);
  const [r, setR] = useState({ from: iso(from), to: iso(to) });
  return [r, setR];
}

export function RangeBar({ r, setR, right }) {
  const quick = (d) => setR({ from: iso(new Date(Date.now() - (d - 1) * 864e5)), to: iso(new Date()) });
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm">
      <Input type="date" className="w-40" value={r.from} onChange={(e) => setR({ ...r, from: e.target.value })} data-testid="mk-from" />
      <span>–</span>
      <Input type="date" className="w-40" value={r.to} onChange={(e) => setR({ ...r, to: e.target.value })} data-testid="mk-to" />
      {[7, 30, 90].map((d) => <button key={d} className="px-2 py-1 border rounded text-xs hover:bg-slate-50" onClick={() => quick(d)}>{d} gün</button>)}
      <div className="ml-auto flex gap-2">{right}</div>
    </div>
  );
}

export function Table({ cols, rows, empty = "Veri yok", testid }) {
  return (
    <div className="overflow-x-auto" data-testid={testid}>
      <table className="w-full text-sm">
        <thead><tr className="text-left text-xs text-slate-500 border-b">{cols.map((c) => <th key={c.k || c.h} className={`py-2 pr-3 whitespace-nowrap ${c.right ? "text-right" : ""}`}>{c.h}</th>)}</tr></thead>
        <tbody>
          {rows.map((r, i) => <tr key={i} className="border-b last:border-0 align-top">{cols.map((c) => <td key={c.k || c.h} className={`py-2 pr-3 ${c.right ? "text-right tabular-nums" : ""}`}>{c.f ? c.f(r) : r[c.k]}</td>)}</tr>)}
          {rows.length === 0 && <tr><td colSpan={cols.length} className="py-4 text-slate-500">{empty}</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export function Verdict({ v }) {
  const m = { "Kârlı": "bg-emerald-50 text-emerald-700", "Zararda": "bg-red-50 text-red-700", "İş yok": "bg-amber-50 text-amber-700", "Veri az": "bg-slate-100 text-slate-600" };
  return v && v !== "-" ? <span className={`text-xs px-2 py-0.5 rounded-full ${m[v] || "bg-slate-100"}`}>{v}</span> : <span className="text-slate-400">—</span>;
}

export const Sel = ({ value, onChange, options, className = "", ...p }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} className={`border rounded-md h-9 px-2 text-sm bg-white ${className}`} {...p}>
    {options.map((o) => (Array.isArray(o) ? <option key={o[0]} value={o[0]}>{o[1]}</option> : <option key={o} value={o}>{o}</option>))}
  </select>
);

export async function readCsvFile(file) {
  const buf = await file.arrayBuffer(); const u = new Uint8Array(buf);
  if (u[0] === 0xff && u[1] === 0xfe) return new TextDecoder("utf-16le").decode(buf);
  if (u[0] === 0xfe && u[1] === 0xff) return new TextDecoder("utf-16be").decode(buf);
  return new TextDecoder("utf-8").decode(buf);
}
